/* ============================================================
   PRODUCTPAGINA — beeldcarousel, varianten, omschrijving inkorten en de
   zwevende koopbalk.

   Alles is een laag bovenop een pagina die zonder JavaScript werkt: de beelden
   staan in de DOM, de omschrijving staat er voluit, en het koopformulier is een
   echt formulier.

     c-gallery-main-product     de beeldcarousel op mobiel (Embla)
     c-variant-picker           de opties; wisselt prijs, knop en URL mee
     c-related-products-v2      het rijtje formaten; scrollt alleen
     c-main-product-reassurance de beloftes met bolletjes
     c-tuncat                   omschrijving inkorten
     [data-sticky-atc]          de balk verschijnt als de koopknop uit beeld is
   ============================================================ */

(function () {
  'use strict';

  var stil = function () { return window.matchMedia('(prefers-reduced-motion: reduce)').matches; };

  class GalleryMainProduct extends HTMLElement {
    connectedCallback() {
      this.viewport = this.querySelector('.embla__viewport');
      this.balk = this.querySelector('.embla__progress__bar');
      this.vorige = this.querySelector('.embla__prev');
      this.volgende = this.querySelector('.embla__next');
      if (!this.viewport || !window.EmblaCarousel) return;
      if (this.querySelectorAll('.embla__slide').length < 2) return;

      this.embla = window.EmblaCarousel(this.viewport, {
        align: 'start', containScroll: 'trimSnaps', loop: false,
        slidesToScroll: Number(this.dataset.slidestoscrollDesktop || 1),
        duration: stil() ? 0 : 25,
      });
      this.vorige?.addEventListener('click', () => this.embla.scrollPrev());
      this.volgende?.addEventListener('click', () => this.embla.scrollNext());
      this.embla.on('select', () => this.teken());
      this.embla.on('scroll', () => this.teken());
      this.embla.on('reInit', () => this.teken());
      this.teken();
    }

    disconnectedCallback() { this.embla?.destroy(); }

    teken() {
      if (!this.embla) return;
      const totaal = this.embla.slideNodes().length || 1;
      const stops = this.embla.scrollSnapList().length || 1;
      const inBeeld = Math.max(1, totaal - stops + 1);
      const deel = Math.min(1, inBeeld / totaal);
      const voortgang = Math.max(0, Math.min(1, this.embla.scrollProgress()));
      if (this.balk) {
        this.balk.style.width = `${(deel * 100).toFixed(4)}%`;
        const speling = deel > 0 ? (1 / deel - 1) * 100 : 0;
        this.balk.style.transform = `translate3d(${(voortgang * speling).toFixed(4)}%,0px,0px)`;
      }
      this.vorige?.closest('.container_embla__prev')?.toggleAttribute('data-disabled', !this.embla.canScrollPrev());
      this.volgende?.closest('.container_embla__next')?.toggleAttribute('data-disabled', !this.embla.canScrollNext());
    }
  }

  /* ---------- varianten ----------

     De varianten komen als JSON uit Liquid, met de bedragen al opgemaakt. Dit
     script kiest bij elke wijziging de variant waarvan alle opties kloppen en
     werkt daarna vier dingen bij: de hidden input in elk koopformulier van dit
     product, de prijs (ook die in de knop en in de zwevende balk), de knop
     zelf, en de URL.

     Alleen formulieren binnen [data-main-product-form] doen mee: het koopblok
     en de zwevende balk. Eerder zocht dit op alle items[0][id] op de pagina,
     waardoor ook de koopknop van de cross-sell de variant-id van dit product
     kreeg en het verkeerde product in de wagen legde.

     Combinaties die niet bestaan of op zijn krijgen data-soldout op het label;
     of ze klikbaar blijven regelt de CSS van het blok. */

  var HOOFD = '[data-main-product-form]';

  class VariantPicker extends HTMLElement {
    connectedCallback() {
      const bron = this.querySelector('[data-variant-data]');
      if (!bron) return;
      try { this.varianten = JSON.parse(bron.textContent); } catch (e) { return; }

      this.groepen = [...this.querySelectorAll('.variant-picker__group')];
      this.addEventListener('change', () => this.kies());
      this.markeer();
    }

    /* De gekozen waarde per optiegroep, op volgorde van de opties. */
    waarden() {
      return this.groepen.map((groep) => {
        const select = groep.querySelector('select[data-option-input]');
        if (select) return select.value;
        const aan = groep.querySelector('input[data-option-input]:checked');
        return aan ? aan.value : null;
      });
    }

    zoek(waarden) {
      return this.varianten.find((v) => v.opties.every((o, i) => o === waarden[i]));
    }

    kies() {
      const waarden = this.waarden();
      const variant = this.zoek(waarden);
      this.markeer();

      document.querySelectorAll(`${HOOFD} input[name="items[0][id]"]`).forEach((el) => {
        el.value = variant ? variant.id : '';
      });

      document.querySelectorAll('[data-variant-price]').forEach((el) => {
        el.textContent = variant ? variant.prijs : '';
      });
      document.querySelectorAll('[data-variant-compare]').forEach((el) => {
        el.textContent = variant ? variant.vergelijk : '';
        el.hidden = !(variant && variant.korting);
      });
      document.querySelectorAll('[data-variant-saving]').forEach((el) => {
        el.hidden = !(variant && variant.korting);
      });

      document.querySelectorAll(`${HOOFD} [data-product-form-submit]`).forEach((knop) => {
        const kan = !!(variant && variant.beschikbaar);
        knop.disabled = !kan;
        const label = knop.querySelector('[data-submit-label]');
        if (label) {
          label.textContent = kan
            ? (knop.dataset.labelAdd || label.textContent)
            : (knop.dataset.labelSoldout || label.textContent);
        }
      });

      /* De gekozen waarde naast de naam van de optie. */
      this.groepen.forEach((groep, i) => {
        const plek = groep.querySelector('[data-option-selected]');
        if (plek && waarden[i]) plek.textContent = waarden[i];
      });

      if (variant && this.dataset.updateUrl === 'true' && window.history.replaceState) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      }
    }

    /* Per waarde kijken of er, met de rest van de keuze erbij, nog iets te
       bestellen valt. Zo niet: doorgestreept. */
    markeer() {
      const huidig = this.waarden();
      this.groepen.forEach((groep, index) => {
        groep.querySelectorAll('.variant-picker__option').forEach((label) => {
          const input = label.querySelector('input[data-option-input]');
          if (!input) return;
          const proef = huidig.slice();
          proef[index] = input.value;
          const v = this.zoek(proef);
          label.toggleAttribute('data-soldout', !(v && v.beschikbaar));
        });
      });
    }
  }

  class Reassurance extends HTMLElement {
    connectedCallback() {
      const viewport = this.querySelector('.embla__viewport');
      this.bolletjes = [...this.querySelectorAll('.embla__dot')];
      if (!viewport || !window.EmblaCarousel) return;
      this.embla = window.EmblaCarousel(viewport, { align: 'start', loop: false, duration: stil() ? 0 : 25 });
      this.bolletjes.forEach((b, i) => b.addEventListener('click', () => this.embla.scrollTo(i)));
      this.embla.on('select', () => this.teken());
      this.teken();
    }
    disconnectedCallback() { this.embla?.destroy(); }
    teken() {
      const actief = this.embla.selectedScrollSnap();
      this.bolletjes.forEach((b, i) => b.classList.toggle('is-active', i === actief));
    }
  }

  /* Omschrijving inkorten. Meet pas als de letters er zijn en opnieuw bij een
     andere breedte, anders klopt het aantal regels niet. */
  class Tuncat extends HTMLElement {
    connectedCallback() {
      this.kort = this.querySelector('.main-product-tuncat-description__short');
      if (!this.kort) return;
      this.regels = Number(this.dataset.lines || 4);
      const start = () => this.bepaal();
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(start);
      start();
      this.waarnemer = new ResizeObserver(() => this.bepaal());
      this.waarnemer.observe(this);
    }
    disconnectedCallback() { this.waarnemer?.disconnect(); }
    klem(aan) {
      const s = this.kort.style;
      s.display = aan ? '-webkit-box' : '';
      s.webkitBoxOrient = aan ? 'vertical' : '';
      s.webkitLineClamp = aan ? String(this.regels) : '';
      s.overflow = aan ? 'hidden' : '';
    }
    bepaal() {
      if (this.open) return;
      this.klem(true);
      if (this.kort.scrollHeight <= this.kort.clientHeight + 1) {
        this.klem(false); this.knop?.remove(); this.knop = null; return;
      }
      if (this.knop) return;
      const knop = document.createElement('button');
      knop.type = 'button';
      knop.className = 'main-product-tuncat-description__see-more';
      knop.dataset.tuncatSeeMore = '';
      knop.textContent = this.dataset.more || 'Read more';
      knop.setAttribute('aria-expanded', 'false');
      knop.addEventListener('click', () => {
        this.open = !this.open;
        this.klem(!this.open);
        knop.setAttribute('aria-expanded', String(this.open));
        knop.textContent = this.open ? (this.dataset.less || 'Read less') : (this.dataset.more || 'Read more');
      });
      this.appendChild(knop);
      this.knop = knop;
    }
  }

  /* Op mobiel ligt de omschrijving over het beeld en hangt de hoogte van de
     slide daarvan af; de CSS rekent met --short-description-height. Die moet
     dus de werkelijke hoogte van dat blok krijgen. */
  function korteOmschrijvingHoogte() {
    const galerijen = document.querySelectorAll('.gallery-main-product.v-mobile');
    const meten = () => {
      for (const g of galerijen) {
        const blok = g.querySelector('.product-description--mobile');
        if (!blok) continue;
        const hoogte = Math.round(blok.getBoundingClientRect().height);
        if (g.dataset.kortH !== String(hoogte)) {
          g.dataset.kortH = String(hoogte);
          g.style.setProperty('--short-description-height', `${hoogte}px`);
        }
      }
    };
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(meten);
    else meten();
    window.addEventListener('resize', meten);
  }

  /* De zwevende koopbalk verschijnt pas zodra de knop in het koopblok boven
     uit beeld is gescrold. Eerder was de voorwaarde "niet in beeld", en op
     mobiel staat de knop bij het laden onder de foto: dan stond de balk er
     al voordat iemand de echte knop had gezien. */
  function stickyBalk() {
    const balk = document.querySelector('[data-sticky-atc]');
    const knop = document.querySelector('.buy-main-product [data-product-form-submit]');
    if (!balk || !knop) return;
    const kijker = new IntersectionObserver((rijen) => {
      for (const rij of rijen) {
        const erVoorbij = !rij.isIntersecting && rij.boundingClientRect.bottom < 0;
        balk.classList.toggle('inactive', !erVoorbij);
      }
    }, { threshold: 0 });
    kijker.observe(knop);
  }

  var lijst = [
    ['c-gallery-main-product', GalleryMainProduct],
    ['c-variant-picker', VariantPicker],
    ['c-main-product-reassurance', Reassurance],
    ['c-tuncat', Tuncat],
    ['c-product-images', class extends HTMLElement {}],
    ['c-description-main-products', class extends HTMLElement {}],
    ['c-related-products-v2', class extends HTMLElement {}],
    ['c-product-information', class extends HTMLElement {}],
    ['c-mini-cross-sell', class extends HTMLElement {}],
    ['c-faq', class extends HTMLElement {}],
  ];
  for (var i = 0; i < lijst.length; i++) {
    if (!customElements.get(lijst[i][0])) customElements.define(lijst[i][0], lijst[i][1]);
  }

  function start() { stickyBalk(); korteOmschrijvingHoogte(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
